<template lang="pug">
ds-panel.tg-chat-relink-modal(space="lg")
  ds-panel-element(offset="bottom")
    ds-caption(
      variant="strong"
      :size="['4']"
    ) {{ _('Переподвязать Telegram-чат') }}

  ds-panel-element(offset="bottom")
    ds-caption(size="sm") {{ chatInfo }}

  ds-panel-element(offset="bottom")
    form-line
      form-cell(cols="12")
        f-select(
          name="fromOwner"
          :data="form"
          :super-label="_('Replace')"
          label="_telegramOwnerTitle"
          track-by="_telegramOwnerKey"
          :allow-empty="false"
          :preselect-first="true"
          :options="linkedOwnerOptions"
        )

  ds-panel-element(offset="bottom")
    form-line
      form-cell(cols="12")
        f-select(
          name="ownerType"
          :data="form"
          :super-label="_('Привязать к')"
          label="title"
          track-by="id"
          :allow-empty="false"
          :options="ownerTypeOptions"
          @select="handleOwnerTypeSelect"
        )

  ds-panel-element(offset="bottom")
    form-line
      form-cell(cols="12")
        f-select(
          name="item"
          :data="form"
          :super-label="isLeadMode ? _('Лид') : _('Клиент')"
          :label="itemLabel"
          track-by="id"
          :allow-empty="true"
          :preselect-first="false"
          @search-change="$event => { itemsParams.filters.search = $event; receiveItems(itemsParams); }"
          :options="itemsList || []"
          :loading="itemsLoading"
        )
          template(#afterList="")
            li
              div(
                v-if="!itemsLoading && itemsParams.pagination.total > itemsParams.pagination.offset + itemsParams.pagination.limit"
                v-observe-visibility="visible => getMoreItems(visible)"
              )

  ds-panel-element(offset="top")
    form-line
      form-cell(cols="narrow")
        control-button(
          styling="primary"
          :disabled="isSubmitting || !form.fromOwner || !form.item"
          @click.prevent="submit"
        ) {{ _('Переподвязать') }}

      form-cell(cols="narrow")
        control-button(
          styling="default"
          :disabled="isSubmitting"
          @click.prevent="close"
        ) {{ _('Отмена') }}
</template>

<script>
import { clone } from 'ramda'

import { clients } from '@md/clients/api'
import { leads } from '@md/leads/api'
import { tgChatApi } from '@md/tg-chat/api'

export default {
  name: 'TelegramChatRelinkModal',

  props: {
    chat: {
      type: Object,
      required: true,
    },
    promise: {
      type: Function,
      default: null,
    },
  },

  data() {
    return {
      form: {
        fromOwner: null,
        ownerType: {
          id: 'client',
          title: this._('Клиент'),
        },
        item: null,
      },

      itemsList: [],
      itemsLoading: false,
      itemsParams: {
        pagination: {},
        filters: {},
      },

      isSubmitting: false,
    }
  },

  computed: {
    ownerTypeOptions() {
      return [
        {
          id: 'client',
          title: this._('Клиент'),
        },
        {
          id: 'lead',
          title: this._('Лид'),
        },
      ]
    },

    isLeadMode() {
      return !!(
        this.form.ownerType
        && this.form.ownerType.id === 'lead'
      )
    },

    searchResource() {
      return this.isLeadMode
        ? leads.list
        : clients.list
    },

    itemLabel() {
      return this.isLeadMode
        ? '_telegramSelectTitle'
        : 'objId'
    },

    chatInfo() {
      const parts = [
        this.chat && this.chat.tgUserId
          ? `${this._('Telegram ID')}: ${this.chat.tgUserId}`
          : '',
        this.chat && this.chat.username
          ? `@${this.chat.username}`
          : '',
        this.chat && this.chat.phone
          ? this.chat.phone
          : '',
      ]

      return parts.filter(Boolean).join(' • ')
    },

    // текущие связи Telegram-чата, одну из которых можно заменить.
    linkedOwnerOptions() {
      const clients = Array.isArray(this.chat?.clients)
        ? this.chat.clients
        : []

      const leads = Array.isArray(this.chat?.leads)
        ? this.chat.leads
        : []

      return [
        ...clients.map(item => ({
          ...item,
          _telegramOwnerKey: `client-${item.id}`,
          _telegramOwnerType: 'client',
          _telegramOwnerTitle: `${this._('Клиент')}: ${this.getItemTitle(item)}`,
        })),

        ...leads.map(item => ({
          ...item,
          _telegramOwnerKey: `lead-${item.id}`,
          _telegramOwnerType: 'lead',
          _telegramOwnerTitle: `${this._('Лид')}: ${this.getItemTitle(item)}`,
        })),
      ]
    },

  },

  mounted() {
    const [firstOwner] = this.linkedOwnerOptions

    if (firstOwner) {
      this.form.fromOwner = firstOwner
    }
    this.receiveItems({
      limit: 20,
    })
  },

  methods: {
    // при переключении Client / Lead очищаем старый выбор
    // и загружаем первый page соответствующего списка
    handleOwnerTypeSelect(ownerType) {
      this.form.ownerType = ownerType
      this.form.item = null

      this.itemsList = []
      this.itemsParams = {
        pagination: {},
        filters: {},
      }

      this.receiveItems({
        limit: 20,
      })
    },
    extractListItems(response) {
      if (Array.isArray(response && response.items)) {
        return response.items
      }

      if (
        response
        && response.data
        && Array.isArray(response.data.items)
      ) {
        return response.data.items
      }

      if (Array.isArray(response)) {
        return response
      }

      return []
    },

    receiveItems(parameters) {
      const param = clone(parameters)

      if (param.filters) {
        param.filters = JSON.stringify(parameters.filters)
      }

      this.itemsLoading = true

      return this.searchResource.execute(param)
        .then(res => {
          const items = this.extractListItems(res).map(
            item => this.normalizeSelectItem(item)
          )

          if (parameters.offset) {
            this.itemsList.push(...items)
          } else {
            this.itemsList = items
          }

          this.itemsParams.pagination = res.pagination || {}
          this.itemsLoading = false
        })
        .catch(() => {
          this.itemsList = []
          this.itemsLoading = false

          this.$toast.error(
            this._('Не удалось загрузить список')
          )
        })
    },

    getMoreItems(isVisible) {
      if (this.itemsLoading || !isVisible) {
        return
      }

      const parameters = {
        ...this.itemsParams,
        limit: this.itemsParams.pagination.limit,
        offset:
          this.itemsParams.pagination.offset
          + this.itemsParams.pagination.limit,
      }

      this.receiveItems(parameters)
    },

    normalizeSelectItem(item) {
      return {
        ...item,
        _telegramSelectTitle: this.getItemTitle(item),
      }
    },

    getItemTitle(item) {
      const fullName = [
        item && item.name,
        item && item.middleName,
        item && item.surname,
      ].filter(Boolean).join(' ')

      return (
        item && item.title
        || item && item.displayName
        || item && item.display_name
        || fullName
        || item && item.mainPhone
        || item && item.main_phone
        || item && item.phone
        || item && item.email
        || `#${item && item.id}`
      )
    },

    getPayload() {
      const payload = {}

      if (this.form.fromOwner._telegramOwnerType === 'lead') {
        payload.from_lead = this.form.fromOwner.id
      } else {
        payload.from_user = this.form.fromOwner.id
      }

      if (this.isLeadMode) {
        payload.to_lead = this.form.item.id
      } else {
        payload.to_user = this.form.item.id
      }

      return payload
    },

    async submit() {
      if (
        this.isSubmitting
        || !this.form.fromOwner
        || !this.form.item
        || !(this.chat && this.chat.id)
      ) {
        return
      }

      this.isSubmitting = true

      try {
        const response = await tgChatApi.chat.relink.execute(
          {
            chatId: this.chat.id,
          },
          this.getPayload()
        )

        this.$toast.success(
          this._('Telegram-чат успешно переподвязан')
        )

        if (this.promise) {
          await this.promise(response)
        }

        this.$emit('close')
      } catch (error) {
        this.$toast.error(
          await this.getSubmitError(error)
        )
      } finally {
        this.isSubmitting = false
      }
    },

    close() {
      if (this.isSubmitting) {
        return
      }

      this.$emit('close')
    },

    async getSubmitError(error) {
      let payload = null

      try {
        if (error && error.response && error.response.data) {
          payload = error.response.data
        } else if (error && error.data) {
          payload = error.data
        } else if (
          error
          && typeof error.json === 'function'
        ) {
          payload = await error.json()
        } else {
          payload = error
        }
      } catch (parseError) {
        payload = error
      }

      if (typeof payload === 'string') {
        return payload
      }

      const firstError = (
        payload
        && Array.isArray(payload.errors)
      )
        ? payload.errors[0]
        : null

      const state = firstError && firstError.state

      if (state && typeof state === 'object') {
        const fieldNames = [
          'nonFieldErrors',
          'fromUser',
          'fromLead',
          'toUser',
          'toLead',
        ]

        for (const fieldName of fieldNames) {
          const fieldErrors = state[fieldName]

          if (
            Array.isArray(fieldErrors)
            && fieldErrors.length
            && fieldErrors[0].message
          ) {
            return fieldErrors[0].message
          }
        }
      }

      if (
        firstError
        && typeof firstError.message === 'string'
        && firstError.message
      ) {
        return firstError.message
      }

      if (
        payload
        && typeof payload.message === 'string'
        && payload.message
      ) {
        return payload.message
      }

      return this._('Не удалось переподвязать Telegram-чат')
    },
  },
}
</script>